import React from "react";
import HighlightedCities from "@/components/modules/geo/HighlightedCities";
import { Container } from "reactstrap";

const CityPage = () => {
  return (
    <div>
      <Container
        css={`
          @media (min-width: ${({ theme }: any) => theme.mobileBp}) {
            margin-top: 20px;
          }
        `}
      >
        <HighlightedCities enableSearch showGoBackButton />
      </Container>
    </div>
  );
};

export default CityPage;
